// extracted by mini-css-extract-plugin
export var container = "_sf-0";
export var inputWidth = "_sf-1";